import { render } from "./AdminBoard.vue?vue&type=template&id=62cd79fa"
import script from "./AdminBoard.vue?vue&type=script&lang=js"
export * from "./AdminBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__